import type { AppUser } from './types';

/** Filter der Benutzerseite; leere Werte filtern nicht. */
export interface UserFilter {
  /** Teil von Vorname, Nachname oder E-Mail, Groß-/Kleinschreibung egal */
  search: string;
  role: AppUser['role'] | '';
  /** Abteilungs-ID; Admin und Vorstand sehen alle Abteilungen und passen deshalb immer */
  divisionId: string;
  kind: AppUser['kind'] | '';
  active: 'aktiv' | 'inaktiv' | '';
}

export const EMPTY_USER_FILTER: UserFilter = {
  search: '',
  role: '',
  divisionId: '',
  kind: '',
  active: '',
};

export function filterUsers(users: AppUser[], f: UserFilter): AppUser[] {
  const needle = f.search.trim().toLowerCase();
  return users.filter((u) => {
    if (needle) {
      const text = [u.givenName, u.familyName, u.email].filter(Boolean).join(' ').toLowerCase();
      if (!text.includes(needle)) return false;
    }
    if (f.role && u.role !== f.role) return false;
    if (f.divisionId && u.role === 'abteilungsleiter' && !u.divisionIds.includes(f.divisionId))
      return false;
    if (f.kind && u.kind !== f.kind) return false;
    if (f.active && u.active !== (f.active === 'aktiv')) return false;
    return true;
  });
}
